(function(){
  var bar=document.querySelector('[data-pl-topbar]');if(!bar)return;
  var links=[].slice.call(bar.querySelectorAll('.pl-nav a[href*="#"]'));
  var targets=links.map(function(a){var h=a.getAttribute('href');var id=h.slice(h.indexOf('#')+1);return {a:a,el:id?document.getElementById(id):null};}).filter(function(t){return t.el;});
  function bgOf(el){while(el&&el!==document.documentElement){var c=getComputedStyle(el).backgroundColor;var m=c.match(/[\d.]+/g);if(m&&(m.length<4||+m[3]>0.5))return m;el=el.parentElement;}return [255,255,255];}
  function isDark(m){return (0.299*m[0]+0.587*m[1]+0.114*m[2])<110;}
  var ticking=false;
  function update(){
    ticking=false;
    var h=bar.offsetHeight;
    bar.classList.toggle('is-scrolled',window.scrollY>40);
    bar.style.pointerEvents='none';
    var probe=document.elementFromPoint(Math.round(window.innerWidth/2),h+4);
    bar.style.pointerEvents='';
    var dark=probe&&!bar.contains(probe)&&window.scrollY>40?isDark(bgOf(probe)):false;
    bar.classList.remove('is-on-dark');
    var active=null;
    targets.forEach(function(t){var r=t.el.getBoundingClientRect();if(r.top<=h+40&&r.bottom>h+40)active=t;});
    targets.forEach(function(t){t.a.classList.toggle('is-active',t===active);});var nav=bar.querySelector('.pl-nav');if(nav)nav.classList.toggle('has-active',!!active||window.scrollY>200);
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  update();
})();
